<template>
  <Button
    type="button"
    :class="`${disabled ? 'disabled' : ''} ${classes}`"
    :disabled="disabled"
    :state="state"
    v-on:click="disabled ? null : emit('click', $event)"
  >
    <slot v-if="!text"></slot>
    <span v-else>{{ text }}</span>
  </Button>
</template>

<script setup lang="ts">
import { useTimesyncStore } from "@/stores/timesync";
import { formatInterval } from "@/utils/shop";
import Button from "primevue/button";
import type { Ref } from "vue";
import { computed, onUnmounted, ref, watchEffect } from "vue";
// import {timer} from "../utils/promise";

const props = withDefaults(
  defineProps<{
    state: string;
    unlock?: string;
  }>(),
  {
    state: "reset",
  },
);
const emit = defineEmits(["click"]);
const timesync = useTimesyncStore();

const classes: Ref<string[]> = ref([]);
const disabled = ref(false);
const last = ref(0);
const now = ref(Date.now());
const text = ref("");
let __timer = -1;

const unlockTimestamp = computed(() => {
  let unlock = props.unlock ? new Date(props.unlock).getTime() : 0;

  // TODO: remove this testing
  // unlock = new Date(Date.now() + 1000 * 5).getTime();

  // compensate for server time offset
  if (unlock) {
    unlock -= timesync.offset;
  }

  return unlock;
});

watchEffect(() => {
  now.value = timesync.now;
  let retval = "";
  const dt = Math.abs(last.value - timesync.now);
  last.value = timesync.now;
  if (dt > 30 * 1000) {
    timesync.calculate();
  }

  if (props.unlock) {
    let interval = unlockTimestamp.value - timesync.now;
    if (interval > 0) {
      retval = formatInterval(interval);
      disabled.value = true;
    } else if (disabled.value) {
      disabled.value = false;
    }
  }
  text.value = retval;
});

onUnmounted(() => {});
</script>

<style scoped></style>
